import * as DialogPrimitive from '@radix-ui/react-dialog';
import { X } from 'lucide-react';

import { cn } from '@/lib/utils';

import { SidebarContent, type SidebarProps } from './Sidebar';

type MobileSidebarProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
} & Omit<SidebarProps, 'onNavigate'>;

export const MobileSidebar = ({
  open,
  onOpenChange,
  navItems,
}: MobileSidebarProps) => {
  return (
    <DialogPrimitive.Root open={open} onOpenChange={onOpenChange}>
      <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay className="fixed inset-0 z-40 bg-[rgba(17,24,39,0.45)] backdrop-blur-sm data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0" />
        <DialogPrimitive.Content
          className={cn(
            'fixed inset-y-0 left-0 z-50 w-[min(85vw,260px)] bg-surface-0 shadow-lg outline-none',
            'transition-transform duration-200 ease-out data-[state=open]:translate-x-0 data-[state=closed]:-translate-x-full'
          )}
        >
          <div className="relative h-full">
            <DialogPrimitive.Close className="absolute right-4 top-4 z-10 inline-flex h-9 w-9 items-center justify-center rounded-full border border-border-default bg-surface-0 text-text-secondary transition-colors duration-normal ease-standard hover:bg-surface-1 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/35 focus-visible:ring-offset-2">
              <X className="h-5 w-5" />
              <span className="sr-only">Close navigation</span>
            </DialogPrimitive.Close>
            <SidebarContent
              navItems={navItems}
              onNavigate={() => onOpenChange(false)}
            />
          </div>
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  );
};
